import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.jsx";
import { Button } from "../components/ui/button.jsx";

export default function LoginPage() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState(null);

  const isInternalPath = (path) =>
    typeof path === "string" && path.startsWith("/") && !path.startsWith("//");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLocalError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      const candidate = location.state?.from?.pathname;
      const target = isInternalPath(candidate) ? candidate : "/admin";
      navigate(target, { replace: true });
    } catch (err) {
      setLocalError("Nao foi possivel iniciar sessao.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-background p-6 md:p-12">
      <div className="max-w-2xl mx-auto">
        <header className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gold mb-3">
            Acesso da equipa
          </h1>
          <p className="text-muted text-lg">
            Inicie sessao para gerir marcacoes e horarios.
          </p>
        </header>

        {(localError || error) && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-lg mb-6">
            {localError || error}
          </div>
        )}

        <div className="bg-card border border-border rounded-lg p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="email" className="block text-sm font-medium text-white">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-white placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="password" className="block text-sm font-medium text-white">
                Palavra-passe
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-white placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
              />
            </div>

            <Button type="submit" className="w-full" size="lg" disabled={submitting}>
              {submitting ? "A entrar..." : "Entrar"}
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}
